// extracted by mini-css-extract-plugin
module.exports = {"tabs":"e_lt","title":"e_mt","list":"e_nt","listActive":"e_ot","leftList":"e_pt","rightList":"e_qt","grid":"e_rt"};